import styled from "styled-components";
import { DateInputThemeType } from "../../../types";
import { createDateTheme } from "./DateThemeUtil";

type StyleProps = {
  styles: DateInputThemeType;
};

export const DateRoot = styled.div`
  &&& {
    .date-clearable {
      margin-right: 2rem;
    }

    .date-clearable:after {
      background: rgb(76, 140, 238);
      color: white;
      font-weight: 900;
      font-size: 11px;
    }

    .react-datepicker-popper {
      z-index: 1056 !important;
    }
  }
`;

export const DatePickerStylesWrapper = styled.div<StyleProps>`
  &&& {
    ${(props) => createDateTheme(props.styles)}
  }
  .react-datepicker__aria-live {
    position: absolute;
  }
`;

export const Spacer = styled.div.attrs(() => ({
  className: "mx-2",
}))`
  font-weight: bold;
  font-size: 1.3rem;
`;

export const SelectsHolder = styled.div`
  display: flex;
`;
